<template>
  <div class="basket-group">
    <div class="basket-text">{{ basketAdjustment.description }}</div>
    <div class="basket-cost">
      <div class="basket-price">
        <span class="basket-amount"
          >£{{ basketAdjustment.amount.toFixed(2) }}</span
        >
      </div>
    </div>
  </div>
</template>
<script>
export default {
  components: {},
  props: {
    basketAdjustment: { type: Object, default: null }
  }
};
</script>
